import { gql } from '@apollo/client';

export const GET_COMPANIES_AND_SITES = gql`
  query GetCompanies($filter: CompanyFilter, $paging: CursorPaging) {
    companies(filter: $filter, paging: $paging) {
      edges {
        node {
          id
          name
          sourceName
          sourceId
          sites {
            name
          }
        }
      }
      pageInfo {
        hasNextPage
      }
    }
  }
`;

export const GET_COMPANIES = gql`
  query GetCompanies($filter: CompanyFilter) {
    companies(filter: $filter) {
      edges {
        node {
          id
          name
          sourceName
          sourceId
        }
      }
    }
  }
`;
